import gql from 'graphql-tag';
import * as React from 'react';
import { ChildProps, compose, graphql } from 'react-apollo';

const ProductTagsQuery = gql`
  query {
    productTags {
      id
      name
      title
      color
      slug
    }
  }
`;

interface IInputProps {
  children?: any;
}

interface IResponse {
  data: any;
}

class GetProductTagsQuery extends React.PureComponent<ChildProps<IInputProps, IResponse>> {
  public render() {
    const productTags = (this.props as any).productTags;
    return this.props.children({ productTags });
  }
}

export default compose(
  graphql<IInputProps, IResponse>(ProductTagsQuery, {
    name: 'productTags'
  })
)(GetProductTagsQuery);



// WEBPACK FOOTER //
// ./src/components/Query/ProductTags/ProductTags.tsx